// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__Wrd9x","main":"Layout_main__wyI6H"};